import {useEffect} from 'react';
import './App.css';
import AppRouter from 'router/appRouter';


function App() {

  useEffect(() => {

    
    // fetch('http://localhost/flexionlinebuchung/setup.php')
       fetch('https://flexi-stwsiegen.de//flexionlinebuchung/setup.php')

        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(data => {
            console.log('Setup completed:', data);
        })
        .catch(error => {
            // todo error screen
            console.error('Error during setup:', error);
        });
}, []);

  return (
     <AppRouter />
    
  );
}

export default App;
